var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSourceCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 43.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 2.343,25.944 C 0.938,25.006 0,23.133 0,21.492 0,19.852 0.703,18.33 2.46,17.51 H 2.343 C 10.66,12.59 22.258,6.0299995 29.99,1.4609995 V 12.356 c -3.046,1.757 -7.146,3.749 -17.455,9.255 l 0.117,0.116 c 5.506,2.461 11.832,6.209 17.338,9.489 V 42.228 L 2.343,25.944 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 97.657,17.744 c 1.404,0.938 2.343,2.812 2.343,4.452 0,1.64 -0.703,3.162 -2.461,3.982 h 0.118 C 89.34,31.098 77.741,37.658 70.01,42.227 V 31.332 c 3.046,-1.756 7.146,-3.748 17.455,-9.254 L 87.348,21.962 C 81.843,19.501 75.516,15.753 70.01,12.473 V 1.4609995 L 97.657,17.744 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 46.401,43.688 H 39.39 L 53.48,-4.5462934e-7 h 7.13 L 46.401,43.688 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceCode);
export default __webpack_public_path__ + "static/media/source-code.fedc43256b323963c2393b137b257fae.svg";
export { ForwardRef as ReactComponent };